module.exports = __webpack_public_path__ + "e0361d467f78323fc0fb6919808b0b79.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/places-in-the-house/House1.jpg
// module id = 3362
// module chunks = 0